import React from 'react';
import styled, { css } from 'styled-components';

export interface FacetChipProps {
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

const Chip = styled.button<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: ${(p) => p.theme.radius.sm};
  font-family: ${(p) => p.theme.fontFamily.ui};
  font-size: ${(p) => p.theme.fontSize.sm};
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.1s,
    color 0.1s;

  ${(p) =>
    p.$selected
      ? css`
          background: ${p.theme.colors.neutral.ink};
          border: 1px solid transparent;
          color: #fff;
          font-weight: ${p.theme.fontWeight.semibold};
        `
      : css`
          background: ${p.theme.colors.neutral.panel};
          border: 1px solid ${p.theme.colors.neutral.line};
          color: ${p.theme.colors.neutral.inkSoft};
          font-weight: ${p.theme.fontWeight.medium};
        `}
`;

export function FacetChip({ selected, onClick, children, className }: FacetChipProps) {
  return (
    <Chip
      type="button"
      $selected={selected}
      aria-pressed={selected}
      onClick={onClick}
      className={className}
    >
      {children}
    </Chip>
  );
}
